import { Node } from '@tiptap/core'
import { VueNodeViewRenderer, mergeAttributes } from "@tiptap/vue-3"
import View from "./View.vue"

export default Node.create({
  name: 'Button',

  group: 'block',

  content: 'text*',

  draggable: true,

  marks: '',

  addAttributes() {
    return {
      href: {
        default: null,
      },
      button: {
        default: 'primary'
      },
      justify: {
        default: 'start'
      },
      target: {
        default: '_self',
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'tt-button',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['tt-button', mergeAttributes(HTMLAttributes), 0]
  },

  addNodeView() {
    return VueNodeViewRenderer(View)
  }
})
